import { BackendBet } from '../../types';

export const getDecimalByEntryPrice = (entry: BackendBet) => {
  if (entry.price1) {
    return entry.price1 / 10;
  }

  if (entry.price2) {
    return entry.price2 / 100;
  }

  if (entry.price3) {
    return entry.price3 / 1000;
  }

  return entry.price0;
};
